import React, { useContext, useEffect, useState } from "react";
// import "./Edit_User_Modal.css";
import { Button, Form, Modal } from "react-bootstrap";
import Modal_Heading from "../../Common_Component/Modal_Heading/Modal_Heading";
import Edit_User_Modal_Frame from "../../Common_Component/Common_Modal/Edit_User_Modal/Edit_User_Modal_Frame/Edit_User_Modal_Frame";
import {
  Update,
  findOne,
} from "../../../utils/apis/master/how_to_play/how_to_play";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import { HTTPS } from "../../../utils/common";
import { Context } from "../../../utils/context";
import ModalSave from "../../Common_Component/Common_Modal/Successfull_Modal/ModelSave";
import JoditEditor from "jodit-react";
import Select from "react-select";
function Edit(props) {
  const { UnauthorizedLogOut, IMG_URL } = useContext(Context);
  const id = props.show;
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setError,
    watch,
    getValues,
    control,
    setValue,
    trigger,
  } = useForm();
  const descriptionValue = watch("name");
  useEffect(() => {
    register("name", {
      required: "name is required.",
    });
  }, [register]);
  const onSubmit = async (data) => {
    try {
      const result = await Update(id, data);
      const response = result.data;

      if (HTTPS.ALREADY_REPORTED.code !== response?.code) {
        await setShowModal({
          code: response.code,
          message: response.data,
        });

        setTimeout(() => {
          setShowModal(0);
          props.onHide();
        }, 1000);
      } else {
        setError("type", {
          message: response?.errors?.name?.msg,
        });
      }
    } catch (error) {
      setError("type", {
        type: "manual", // Optional but helps to indicate it's a manual error
        message: error?.response?.data?.errors,
      });
      await UnauthorizedLogOut(error);
      console.error(error.message);
    }
  };

  const GetEditData = async () => {
    if (id) {
      const response = await findOne(id);
      reset(response?.data?.data);
    }
  };
  useEffect(() => {
    GetEditData();
  }, [id]);

  return (
    <>
      <section>
        <Modal
          {...props}
          className="Edit_User_Modal modal_holder"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered>
          <Modal_Heading modalHeading={"Edit How To Play"} />
          <div className="modal-body-holder">
            {/* <Edit_User_Modal_Frame /> */}
            <Modal.Body>
              <div className="main-form-holder">
                <Form className="form-holder" onSubmit={handleSubmit(onSubmit)}>
                  <div className="row">
                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail">
                        <Form.Label>Name*</Form.Label>
                        <Controller
                          name="name" // Provide the field name
                          control={control} // Pass the control object from useForm()
                          rules={{
                            required: "Name is required",
                          }} // Validation rules
                          render={({ field }) => (
                            <JoditEditor
                              value={descriptionValue || ""}
                              onBlur={(newContent) => {
                                setValue("name", newContent);
                                trigger("name");
                              }}
                            />
                          )}
                        />
                        {errors.name && (
                          <span className="text-danger">
                            {errors.name.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </div>
                </Form>

                <div className="modal-footer-holder">
                  <div className="d-flex justify-content-center align-items-center">
                    <Button
                      className="search-btn mx-2"
                      onClick={() => {
                        props.onHide();
                        reset();
                      }}>
                      Cancel
                    </Button>

                    <Button
                      className="reset-btn mx-2"
                      type="button"
                      onClick={handleSubmit(onSubmit)}>
                      Submit
                    </Button>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </div>
        </Modal>
        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </section>
    </>
  );
}

export default Edit;
